export const STARTUP_CATALOG = [
  { key: 'cleanup', label: 'Initial cleanup & haul-off', default: 2500 },
  { key: 'mulch',   label: 'Mulch / DG top-dress',       default: 4200 },
  { key: 'audit',   label: 'Full irrigation audit',      default: 1200 },
  { key: 'plant',   label: 'Plant / color install',      default: 1800 },
];

const startup = (on) => STARTUP_CATALOG.reduce((acc, it) => ({
  ...acc, [it.key]: { on: on.includes(it.key), cost: it.default },
}), {});

// Structural placeholder defaults. Per-role knobs are { mode, hoursPct, freqMult }
// (+ days/cov/fi where relevant). Real hours/cost are derived from the takeoff
// service lines at compute time, NOT stored here. Arborist seeds tree/palm COUNTS
// from the takeoff seed. fi=8 -> 2x/yr, fi=6 -> 4x/yr, fi=9 -> 1x/yr.
export function buildDefaultFlavors(seed = {}) {
  const trees = seed.Arborist?.trees || 0;
  const palms = seed.Arborist?.palms || 0;
  const maint = (days, hoursPct = 100) => ({ mode: 'in', hoursPct, freqMult: 1, days, blowGo: 0, prune: 'shear' });
  const irr  = (cov, hoursPct = 100) => ({ mode: 'in', hoursPct, freqMult: 1, cov });
  const arb  = (mode, fi) => ({ mode, hoursPct: 100, freqMult: 1, fi, trees, palms });
  return [
    { id: 'basic', name: 'Basic', recommended: false,
      svc: { Maint: maint(1), Irrigation: irr(0), Herbicide: { mode: 'off', fi: 8 },
             Arborist: arb('off', 9), Fert: { mode: 'off', fi: 9 } },
      startup: startup(['cleanup']) },
    { id: 'standard', name: 'Standard', recommended: true,
      svc: { Maint: maint(1), Irrigation: irr(1), Herbicide: { mode: 'in', fi: 8 },
             Arborist: arb('off', 9), Fert: { mode: 'off', fi: 9 } },
      startup: startup(['cleanup', 'audit']) },
    { id: 'premium', name: 'Premium', recommended: false,
      svc: { Maint: maint(2), Irrigation: irr(2), Herbicide: { mode: 'in', fi: 8 },
             Arborist: arb('in', 9), Fert: { mode: 'in', fi: 9 } },
      startup: startup(['cleanup', 'mulch', 'audit', 'plant']) },
  ];
}
